module.exports = __webpack_public_path__ + "assets/Image 256.a1a5cb3a.svg";